import type { Task } from './models';

/**
 * Instant used for ETA on-time / breached scoring.
 * Pending closure request freezes the clock at [closureRequestedAt].
 * Accepted closure (late supervisor approve) uses [lastClosureRequestedAt].
 */
export function etaClockInstant(t: Task, now: Date = new Date()): Date {
  if (t.status === 'closed') {
    if (
      t.lastClosureRequestStatus === 'accepted' &&
      t.lastClosureRequestedAt
    ) {
      return t.lastClosureRequestedAt;
    }
    return t.closedAt ?? now;
  }
  if (t.hasClosureRequest) {
    // Freeze at request time; if timestamp missing, treat as on-time (not past ETA).
    return t.closureRequestedAt ?? t.eta ?? now;
  }
  return now;
}

/** Matches mobile `AppTask.isPastEta` with closure-request freeze. */
export function taskIsPastEta(t: Task, now: Date = new Date()): boolean {
  if (!t.eta) return false;
  return etaClockInstant(t, now).getTime() > t.eta.getTime();
}
